import type { $TSFixMe } from '@readme/iso';

import React from 'react';
import { useSlateStatic } from 'slate-react';

import RDMD from '@ui/RDMD';

const RenderMarkdown = ({ body = '' }: { body?: string }) => {
  const editor = useSlateStatic();
  const { renderingLibrary } = editor;
  const { useMDX, variableDefaults } = editor.props;
  let Context: $TSFixMe;

  if (!useMDX) {
    Context = renderingLibrary.utils.VariablesContext;
  }

  return useMDX ? (
    <RDMD body={body} format="mdx" renderer="rmdx" />
  ) : (
    <Context.Provider value={{ defaults: variableDefaults, user: [] }}>
      <RDMD body={body} renderer="rdmd" />
    </Context.Provider>
  );
};

export default RenderMarkdown;
